import { Fragment, useRef } from "react";
import { BsTruck } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import { Dialog, Transition } from "@headlessui/react";
import { IoMdInformationCircleOutline } from "react-icons/io";

const AddressClusterChangeModal = ({
  isOpen,
  onClose,
  setActiveModal,
  activeCartDetails,
  onConfirm,
  pendingAddress,
}) => {
  const cancelButtonRef = useRef(null);

  return (
    <div>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 sm:max-w-xl sm:w-full sm:p-6`}
                >
                  <button onClick={onClose} className="absolute top-6 right-3 text-gray-500 hover:text-gray-700">
                    <FaTimes className="w-4 h-4" />
                  </button>
                  <div className="flex gap-2 items-center text-red-500">
                    <IoMdInformationCircleOutline />
                    <div className="font-semibold text-sm">
                      The address you selected belongs to a different delivery cluster.
                    </div>
                  </div>

                  <div className="mt-3 text-sm">
                    Item pricing and availability may differ for the selected address. Please re-verify the home
                    delivery cart with the client before checkout.
                  </div>
                  <div className="rounded-lg bg-[#f4f4f4] p-3 mt-5">
                    {pendingAddress && (
                      <>
                        <div className="flex gap-2 items-center">
                          <div className="font-medium text-sm">Delivery Address</div>
                          <div
                            className={`rounded-2xl py-1 px-3 text-[10px] font-medium
                                          ${pendingAddress?.label === "Home" ? "bg-[#e7f8ef] text-[#07863d]" : ""}
                                          ${pendingAddress?.label === "Office" ? "bg-[#f8e7d6] text-[#a75610]" : ""}
                                          ${pendingAddress?.label === "Others" ? "bg-[#eff1ff] text-[#3969ff]" : ""}`}
                          >
                            {pendingAddress?.label}
                          </div>
                          {pendingAddress.previously_ordered && (
                            <div className="rounded-md bg-[#dedede] text-[#666666] w-24 p-1 text-[10px] text-center">
                              Last Delivered
                            </div>
                          )}
                        </div>
                        <div className="text-[#6a717e] text-xs mt-3">{pendingAddress?.address_1}</div>
                        <div className="text-[#6a717e] text-xs mt-1">{pendingAddress?.address_2}</div>
                      </>
                    )}
                    <div className="flex gap-2 items-center mt-2">
                      <BsTruck className="w-5 h-5 text-black" />
                      <div className="text-[#6a717e] text-xs">
                        Delivered by{" "}
                        <span className="text-black font-medium">
                          {activeCartDetails?.price_breakup?.delivery_status}
                        </span>
                      </div>
                    </div>
                    <div className="mt-5">
                      <button
                        type="button"
                        onClick={() => {
                          onClose();
                          setActiveModal("addressList");
                        }}
                        className="rounded-lg w-full px-10 py-[9px] text-sm shadow-sm text-[#0069fe] bg-white font-medium"
                      >
                        Change Address
                      </button>
                    </div>
                  </div>
                  <div className="mt-3">
                    <button
                      className="bg-[#01883c] text-white px-3 py-2 text-center w-full rounded-md"
                      onClick={() => {
                        onConfirm(pendingAddress);
                        onClose();
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default AddressClusterChangeModal;
